import { CardManagementTypes } from "../globals/types"





let initialValue = {
    data: {},
    is_loading: false
}



export const cardManagementReducer = (state = initialValue, action) => {
    switch (action.type) {
        case CardManagementTypes.UPDATE_STATE:
            return {
                ...state,
                data: action.data,
                is_loading: action.is_loading
            }
        default:
            return { ...state }
    }
}